/** @jsx h */
/** @jsxFrag Fragment */
import { type ComponentChildren, h } from "preact";
import { cx } from "@utils/utils";
import { type ShushView, useShushApp, useShushAppSelect } from "@/spa/app/app.tsx";

const ViewLabels: Record<ShushView, string> = {
  play: "play",
  config: "config",
};

export interface ShellProps {
  banner?: ComponentChildren;
  children: ComponentChildren;
}
export function Shell(props: ShellProps) {
  const app = useShushApp();
  const view = useShushAppSelect((s) => s.view);
  const dirty = useShushAppSelect((s) => s.dirty);

  const go = (next: ShushView) => {
    if (next === view) return;
    if (view === "config" && dirty && !confirm("Discard unsaved changes?")) return;
    app.dispatch({ type: "view", payload: { view: next } });
  };

  return (
    <div class="shell">
      {props.banner}
      <header class="shell-top">
        <span class="shell-title">shusher</span>
      </header>
      <main class="shell-center">{props.children}</main>
      <nav class="shell-bottom">
        {(Object.keys(ViewLabels) as ShushView[]).map((v) => (
          <button
            key={v}
            type="button"
            class={cx("shell-tab", v === view && "active")}
            onClick={() => go(v)}
          >
            {ViewLabels[v]}
          </button>
        ))}
      </nav>
    </div>
  );
}
